import {Injectable} from '@angular/core';

import SessionState from '@app/core/states/session.state';

@Injectable({providedIn: 'root'})
export default class SessionFacade {
  public currentSession$           = this._state.currentSession$;
  public sessionFiltered$          = this._state.sessionFiltered$;
  public sessionFilteredId$        = this._state.sessionFilteredId$;
  public sessionWithCustomRangeId$ = this._state.sessionWithCustomRangeId$;
  public sessionsFiltered$         = this._state.sessionsFiltered$;
  public sessionsWithCustomRange$  = this._state.sessionsWithCustomRange$;

  public updateCustom                   = this._state.updateCustom.bind(this._state);
  public updateSessionFilteredId        = this._state.updateSessionFilteredId.bind(this._state);
  public updateSessionWithCustomRangeId = this._state.updateSessionWithCustomRangeId.bind(this._state);

  public constructor(private readonly _state: SessionState) {}
}
